/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

$(document).ready(function(){
	jQuery('.loader-block').hide();

	// Ensure the immediate parent of the shipping estimator spans full width
	var $calc = jQuery('.machship-shipping-calculator').first();
	if ($calc.length && $calc.parent().length) {
		$calc.parent().css('width', '100%');
	}

	var ms_domain = 'https://sync.fusedship.com',
		rateRequest = false,
		additionalParam = 'hide_upez_cart=true';

	// just like upez cart, we skip the open cart for Rebuy SmartCart
	if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
		Rebuy.SmartCart.skip_open = true;
	}

	"object" == typeof Countries &&
	(Countries.updateProvinceLabel = function (e, t) {
		if ("string" == typeof e && Countries[e] && Countries[e].provinces) {
			if (
				"object" != typeof t &&
				((t = document.getElementById("address_province_label")), null === t)
			)
				return;
			t.innerHTML = Countries[e].label;
			var r = jQuery(t).parent();
			r.find("select");
			r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0]);
		}
	}),
	"undefined" == typeof Shopify.Cart && (Shopify.Cart = {}),
	(Shopify.Cart.ShippingCalculator = (function () {

		var cartData = [],
				_config = {
				submitButton: "Calculate shipping",
				submitButtonDisabled: "Calculating...",
				templateId: "shipping-calculator-response-template",
				wrapperId: "wrapper-response",
				customerIsLoggedIn: !1,
				moneyFormat: "${{amount}}",
			},
			loader = jQuery('.loader-block'),
			_enableLoader = function () {
				loader.hide();
			},
			_disableLoader = function () {
				loader.show();
			},
			_getCartShippingRatesForDestination = function (e) {

				var quoteForm = $('form[action="/cart/add"], form[id="ajax-add-to-cart-form"]'),
					selectedProductId = "";

				// loop through all the quote forms UNTIL get the selected product id
				$.each(quoteForm, function (index, form) {
					var eachForm = quoteForm.eq(index),
						productId = eachForm.find('input[name="id"]').val(),
						selectedProductId_1 = eachForm.find('select[name="id"]').find('option:eq(0)').val(), // this is to get the product in hidden form without user click
						selectedProductId_2 = eachForm.find('select[name="id"]').find('option:selected').val(); // this is to get the product upon user click

					if (productId > 0) {
						selectedProductId = productId;
					}
					else if (selectedProductId_1 > 0) {
						selectedProductId = selectedProductId_1;
					}
					else if (selectedProductId_2 > 0) {
						selectedProductId = selectedProductId_2;
					}
					if (selectedProductId.length > 0) {
						return false; // break the loop
					}
				});


				// first we need to fetch all the products in cart
				// then store them in a variable
				// then we empty the cart
				// and add only the product that we want to get the shipping rates
				// after getting the shipping rates we delete that added product
				// finally we add the products back to the cart

				rateRequest = true;
				var addData = {
					'id': selectedProductId,
					'quantity': $('input[name="quantity"]').val()
				};

				fetch('/cart.js', {
						method: 'GET',
						credentials: 'same-origin',
						headers: {
								'Content-Type': 'application/json',
						}
				}).then(function(response) {
					return response.json();
				}).then(function(json) {
					var cartItems = json.items;
					cartData = [];
					$.each(cartItems, function (index, item) {
						cartData.push({
							id: item.id,
							quantity: item.quantity
						});
					});

					fetch('/cart/clear.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
								'Content-Type': 'application/json',
						}
					}).then(function(response) {
						return response.json();
					}).then(function(json) {
						fetch(`/cart/add.js?${additionalParam}`, {
							body: JSON.stringify(addData),
							credentials: 'same-origin',
							headers: {
									'Content-Type': 'application/json',
									'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
							},
							method: 'POST'
						}).then(function(response) {
								return response.json();
						}).then(function(json) {
								if (json.status) {
									var customMessage = "";
									if (json.description == "Required parameter missing or invalid: id") {
										customMessage = "Please select a from product options before quoting.";
									}
									_customErrorHandler(json, customMessage);
									return;
								}
								$.ajax({
										type: "GET",
										url: '/cart/shipping_rates.json',
										data: jQuery.param({
												shipping_address: e
										}),
										success: function (r, n, a) {
											200 === a.status
												? _onCartShippingRatesUpdate(r.shipping_rates, e)
												: setTimeout(t, 500);

											rateRequest = false;

											_updateProductQuantity();

											if (r.shipping_rates && r.shipping_rates.length <= 0) {
												_customErrorHandler(r, "No shipping rates available for this destination.");
											}
										},
										error: function (r, n, a) {

											var data = eval("(" + r.responseText + ")"),
												customMessage = "";

											if (data.zip && data.zip[0] && data.zip[0].length > 0 ) {
												customMessage = data.zip[0];
											}
											if (data.province && data.province[0] && data.province[0].length > 0 ) {
												customMessage = data.province[0];
											}
											_customErrorHandler(r, customMessage);
										},
										dataType: 'json'
								});

						}).catch(function(err) {
							var data = eval("(" + err.responseText + ")"),
								customMessage = "";

							if (data && data.description && data.description == "Required parameter missing or invalid: id") {
								customMessage = "Please select a from product options before quoting.";
							}
							_customErrorHandler(err, customMessage);
						});
					}).catch(function(err) {
						rateRequest = false;
						console.error(err);
					});
				});
			},
			_fullMessagesFromErrors = function (e) {
				var t = [];
				return (
					jQuery.each(e, function (e, r) {
						jQuery.each(r, function (r, n) {
							t.push(e + " " + n);
						});
					}),
					t
				);
			},
			_customErrorHandler = function (error, customMessage) {
				var feedback = "";

				if (customMessage.length > 0) {
					feedback = customMessage;
				}
				else {
					var data = eval("(" + error.responseText + ")");
					feedback = data &&data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".";
				}

				$('.msc-w-response').html('<ul id="shipping-rates" class="msc-rates-list"><li><strong>ERROR:</strong> '+feedback+'</li></ul>');
				$('.msc-w-response').show();
				jQuery("#estimated-shipping").hide(),
				jQuery("#estimated-shipping em").empty(),
				_enableLoader();
				rateRequest = false;
			},
			_customRender = function (rates) {
				var ratesList = '<ul id="shipping-rates" class="msc-rates-list">';
				$.each(rates, function (index, rate) {
					ratesList += '<li><span><strong>'+rate.name+'</strong> - '+rate.price+'</span></li>';
				});
				ratesList += '</ul>';
				$('.msc-w-response').html(ratesList);
				$('.msc-w-response').show();
				jQuery("#estimated-shipping").hide(),
				jQuery("#estimated-shipping em").empty(),
				_enableLoader();
			},
			_onError = function (XMLHttpRequest, textStatus) {
				jQuery("#estimated-shipping").hide(),
				jQuery("#estimated-shipping em").empty(),
				_enableLoader();

				var feedback = "",
					data = eval("(" + XMLHttpRequest.responseText + ")");
					(feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + "."),
					"Error : country is not supported." === feedback && (feedback = "We do not ship to this destination.");
					_render({ rates: [], errorFeedback: feedback, success: !1 });
					jQuery("#" + _config.wrapperId).show();
					_updateProductQuantity();

			},
			_updateProductQuantity = function () {

				// clear the cart
				fetch('/cart/clear.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
							'Content-Type': 'application/json',
					}
				}).then(function(response) {
					return response.json();
				}).then(function(json) {
					if (cartData.length == 0) {
						return;
					}
					let formData = {
						'items': cartData
						};
					// add the products back to the cart
					fetch(`/cart/add.js?${additionalParam}`, {
						method: 'POST',
						body: JSON.stringify(formData),
						credentials: 'same-origin',
						headers: {
								'Content-Type': 'application/json',
								'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
						}
					}).then(function(response) {
							return response.json();
					}).then(function(json) {
						console.log('Product added to cart');
					}).catch(function(err) {
						console.error(err);
					});
				}).catch(function(err) {
					console.error(err);
				});
			},
			_onCartShippingRatesUpdate = function (e, t) {
				_enableLoader();
				var r = "";
				if (
					(t.zip && (r += t.zip + ", "),
					t.province && (r += t.province + ", "),
					(r += t.country),
					e.length)
				) {
					"0.00" == e[0].price
						? jQuery("#estimated-shipping em").html("FREE")
						: jQuery("#estimated-shipping em").html(e[0].price);
					for (var n = 0; n < e.length; n++) {
						// e[n].price = _formatRate(e[n].price);
						e[n].price = "$" + e[n].price;
					}
				}
				_customRender(e),
				jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn();
			},
			_formatRate = function (e) {
				function t(e, t) {
					return "undefined" == typeof e ? t : e;
				}
				function r(e, r, n, a) {
					if (
						((r = t(r, 2)),
						(n = t(n, ",")),
						(a = t(a, ".")),
						isNaN(e) || null == e)
					)
						return 0;
					e = (e / 100).toFixed(r);
					var i = e.split("."),
						o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
						s = i[1] ? a + i[1] : "";
					return o + s;
				}
				// if ("function" == typeof Shopify.formatMoney)
				//   return Shopify.formatMoney(e, _config.moneyFormat);
				"string" == typeof e && (e = e.replace(".", ""));
				var n = "",
					a = /\{\{\s*(\w+)\s*\}\}/,
					i = _config.moneyFormat;
				switch (i.match(a)[1]) {
					case "amount":
						n = r(e, 2);
						break;
					case "amount_no_decimals":
						n = r(e, 0);
						break;
					case "amount_with_comma_separator":
						n = r(e, 2, ".", ",");
						break;
					case "amount_no_decimals_with_comma_separator":
						n = r(e, 0, ".", ",");
				}
				return i.replace(a, n);
			},
			_getRate = function(e) {
				var e = {};
				(e.zip = jQuery("#address_zip").val() || ""),
				(e.country = jQuery("#address_country").val() || ""),
				(e.province = jQuery("#hidden_state").val() || ""),
				(e.city=jQuery("#address_city").val() || "");
				if (e.zip.length <= 0 || e.country.length <= 0 || e.city.length <= 0) {

					jQuery("#" + _config.wrapperId).html("<center><span style='color: red;'>Please fill up all the fields.</span></center>").show();
					return;
				}
				_disableLoader(),
				jQuery("#" + _config.wrapperId)
					.empty()
					.hide();

				if (!rateRequest) {
					_getCartShippingRatesForDestination(e);
				}
			};
		return (
			(_init = function () {
				var e = jQuery("#address_country"),
					t = jQuery("#address_province_label").get(0);
				"undefined" != typeof Countries &&
					(Countries.updateProvinceLabel(e.val(), t),
					e.change(function () {
						Countries.updateProvinceLabel(e.val(), t);
					})),
					stateOptions = jQuery('#address_province option'),
					address_zip = jQuery("#address_zip").val() || "",
					loadingText = '<a href="" data-state="" data-suburb="">LOADING...</a>';

					// LOCATION REQUEST
					var oldVal = "",
					timeoutId = "";

					if (e.find('option:selected').val() == '---' || e.find('option:selected').val() == '') {
						e.find("option:contains(Australia)").attr('selected', true);
					}

					jQuery("#address_zip").on('input', function(e) {

						if ($("#zip-list").children('a').length) {
							$('#zip-list').attr('style', '');
						}
						else {
							$('#zip-list').html("");
							$('#zip-list').append(loadingText);
						}

						var currVal = this.value;
						clearTimeout(timeoutId);
						// validate if input is number and exclude those alt, tab etc press
						if(e.which != 8 && isNaN(String.fromCharCode(e.which))){
								e.preventDefault(); //stop character from entering input
						}

						// check if the current input is already 4 characters and not the same as the old value
						if (
							jQuery.isNumeric(currVal) &&
							currVal.length == 4 &&
							oldVal != currVal
						) {

							// set timeout to 1 second before sending request
							// because customer might be deciding the last digit
							// and to avoid sending the requeest over and over
							timeoutId = setTimeout(function() {

								// set the default value of select dropdown
								$('#zip-list').html("");
								$('#zip-list').append(loadingText);

								$.ajax({
										type: "GET",
										url: ms_domain + '/machship-api/location-request',
										data: jQuery.param({
											domain: Shopify.shop,
											postcode: currVal,
											cdn: "https://" + Shopify.cdnHost,
											platform: "Shopify"
										}),
										success: function (response) {
											if (response.data && response.status) {
												// update the old value to the current value
												oldVal = currVal;
												$('#zip-list').html("");
												$('#zip-list').append('<a href="">&nbsp;</a>');

												currVal = currVal.replace(/^0+/, ''); // removes leading zeros

												// sort the response data by description Aa-Zz
												var sortedResponse = response.data.sort(function(a, b) {
													return a.description.localeCompare(b.description);
												});

												// map the response data to the select dropdown
												$.each(sortedResponse, function (index, value) {
													if (currVal == value.postcode) {
														$('#zip-list').append('<a href="" data-state="'+value.state.code+'" data-suburb="'+value.suburb+'">' + value.description + '</a>');
													}
												});
											}
											else {
												// if there is no data, show the error message
												$('#zip-list').html('<a>'+JSON.stringify(response.data)+'</a>');
											}
										},
										error: function (err) {
											// update the old value to the current value
											oldVal = currVal;
											// since it's error show the error message
											$('#zip-list').html('<a>'+JSON.stringify(err)+'</a>');
											console.error("error",err);
										}
								});
							}, 1000);
						}
					});

					jQuery("#address_zip").on('click', function(){
						if ($("#zip-list").children('a').length) {
							$('#zip-list').attr('style', '');
						}
					});

					jQuery("#zip-list").on('blur', function(){
						$('#zip-list').attr('style', 'display:none;');
					});

					jQuery("#zip-list").on('click', 'a', function (e) {
						e.preventDefault();
						$('#zip-list').attr('style', 'display:none;');
						var suburb = $(this).data('suburb');
						var state = $(this).data('state');
						// Validate that suburb and state are not empty, not null, and are strings
						if (
							typeof suburb === 'string' && suburb.trim().length > 0 &&
							typeof state === 'string' && state.trim().length > 0
						) {
							$('#address_city').val(suburb);
							$('#hidden_state').val(state);
							_getRate();
						} else {
							_customErrorHandler(e, "Invalid suburb or state data.");
						}
					});
			}),
			{
				show: function (e) {
					_init();
				},
				getConfig: function () {
					return _config;
				},
				formatRate: function (e) {
					return _formatRate(e);
				},
			}
		);
	})());
});
